/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;

  .profileBuilderLeftSide {
    flex-basis: 47%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 48px;
  }

  .left-side {
    flex-basis: 47%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 42px;
  }

  .mockupHintParagraph {
    font-family: "SF Pro Display";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: ${({ theme }) => theme.primaryDark};
  }

  .profileBuilderRightSide {
    flex-basis: 47%;
    display: flex;
    justify-content: center;
  }

  .right-side {
    flex-basis: 47%;
    display: flex;
    justify-content: center;
  }
`;

export const SharePageContainer = styled.div`
  font-family: 'Proxima Nova', sans-serif;
  min-height: 100vh;
  background-color: rgb(247, 245, 242);
  position: relative;
  @media (min-width: 768px) {
    padding: 40px 20px;
  }
  
  .share-page-wrapper {
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    overflow: hidden;
    background-color: rgb(241, 239, 232);
    @media (min-width: 768px) {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
    }
  }
`;

export const QRCodeBox = styled.div`
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  background-color: #000000;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;

  svg {
    background-color: #ffffff;
    padding: 8px;
    border-radius: 4px;
  }

  .qr-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  span {
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 1.4;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;